<template>
  <div>
    <div v-if="lockoutPeriod">
      <v-row>
        <v-col>
          <v-card>
            <h3>{{ lockoutMessage }}</h3>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="mb-4"> Create Invoice </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-menu
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      eager
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Invoice Month"
                          v-model="selectedMonth"
                          class="header-inputs flex-grow-0"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="isLoadingCbs || isLoadingUninvoicedTickets"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="selectedMonth" type="month"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="selectedUnit"
                      :items="units"
                      label="Unit"
                      item-text="name"
                      required
                      hide-details="auto"
                      class="mb-6"
                      outlined
                      dense
                      :disabled="isLoadingCbs || isLoadingUninvoicedTickets"
                    ></v-select>
                  </v-col>
                  <v-col md="3">
                    <v-menu
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      eager
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Invoice Date"
                          v-model="invoiceDate"
                          class="header-inputs flex-grow-0"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          @blur="checkForLockoutPeriod()"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="invoiceDate"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <!-- <v-form ref="form"> -->
                    <v-text-field
                      v-model="invoiceNumber"
                      label="Enter unique invoice number"
                      outlined
                      dense
                      :rules="[rules.required, rules.emailMatch, rules.alphaNumeric]"
                      @blur="checkForLockoutPeriod()"
                    ></v-text-field>
                    <!-- </v-form> -->
                  </v-col>
                  <CBSTotalsv2
                    v-if="ticketList !== null"
                    :ticketList="ticketList"
                    @updateTotals="updateTotals"
                    :style="`${totals !== null && !isLoadingCbs ? '' : 'display:none'}`"
                  />
                </v-row>

                <v-row v-if="isLoadingCbs || isLoadingUninvoicedTickets" class="d-flex justify-center">
                  <div class="d-flex justify-center">
                    <half-circle-spinner :animation-duration="1000" :size="60" :color="'white'" />
                  </div>
                </v-row>
                <div v-if="totals !== null && !isLoadingCbs && !isLoadingUninvoicedTickets">
                  <v-row>
                    <v-col>
                      <div v-if="!invoiceSubmitted">
                        <v-row>
                          <v-col>
                            <v-switch
                              v-model="isReportVisible"
                              inset
                              class="mt-0"
                              :label="`Show report data`"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-switch
                              v-if="isReportVisible"
                              v-model="showApprovedTickets"
                              inset
                              class="mt-0"
                              :label="`Show approved tickets`"
                            ></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-alert v-if="unApprovedTicketCount > 0" color="primary" dark density="compact">
                              <p :style="{ 'font-size': '12px' }">
                                There are unapproved tickets in the current date selection. All tickets must be approved
                                before an invoice can be submitted.
                              </p>
                            </v-alert>
                            <v-alert v-if="uninvoicedTickets.length" color="primary" dark density="compact">
                              <p :style="{ 'font-size': '12px' }">
                                There are uninvoiced tickets from previous months. All tickets from previous months must
                                be submitted before an invoice for this month can be submitted.
                              </p>
                            </v-alert>
                            <v-checkbox
                              v-else
                              v-model="agreement"
                              label="I agree to the totals"
                              class="shrink mr-4 mt-0"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn color="primary" class="mr-3" @click="viewPDF" :disabled="isSubmitDisabled()">
                              View PDF <v-icon v-if="!submitLoading" class="ml-2">{{ icons.mdiFileEyeOutline }}</v-icon>
                            </v-btn> </v-col
                          ><v-col>
                            <v-btn color="success" @click="submitInvoice" :disabled="isSubmitDisabled()">
                              Submit <v-icon v-if="!submitLoading" class="ml-2">{{ icons.mdiUpload }}</v-icon>
                              <half-circle-spinner
                                class="ml-2"
                                v-else
                                :animation-duration="1000"
                                :size="20"
                                :color="'white'"
                              />
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="mt-3" v-else>
                        <h3>
                          Invoice #
                          <a @click="viewPDF">{{ invoiceNumber }}</a>
                          has been successfully submitted
                        </h3>
                      </div>
                    </v-col>
                    <v-col v-if="!invoiceSubmitted" class="ml-16 mr-16" cols="6">
                      <v-progress-linear
                        v-if="submitLoading"
                        :value="loadingValue"
                        stream
                        buffer-value="0"
                        color="primary"
                      ></v-progress-linear>
                      <h3 v-if="submitLoading" class="d-flex justify-center mt-3">{{ loadingMessage }}</h3>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- <v-alert type="error">Hello</v-alert> -->
      <!-- <button @click="sendEmail()">Send Email</button> -->

      <CBSDatav2
        :ticketList="ticketList"
        :isReportVisible="isReportVisible"
        @updateApprovedTicketCount="updateApprovedTicketCount"
        :showApprovedTickets="showApprovedTickets"
      ></CBSDatav2>
    </div>
  </div>
</template>

<script>
import { RailwayApiService } from '@/services/railwayApiService'
import { mdiFileEyeOutline, mdiUpload } from '@mdi/js'
import { HalfCircleSpinner } from 'epic-spinners'
import firebase from 'firebase'
import moment from 'moment'
const axios = require('axios').default

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import CBSDatav2 from '../components/CBSDatav2.vue'
import CBSTotalsv2 from '../components/CBSTotalsv2.vue'
// import { generateTicketList } from '../components/GenerateTicketLlist.js'
import { generateTicketList } from '../components/GenerateTicketListV2.js'
import { generateDocDefinition } from '../components/invoicePDF.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  data() {
    return {
      docDefinition: null,
      orgData: null,
      agreement: false,
      selectedMonth: null,
      invoiceDate: null,
      invoiceNumber: null,
      selectedUnit: null,
      units: [],
      usedInvoiceNumbers: [],
      ticketListWithInvoiced: null,
      isLoadingCbs: false,
      isLoadingUninvoicedTickets: false,
      submitLoading: false,
      invoiceSubmitted: false,
      totals: null,
      revenue: null,
      deductions: null,
      afterCommission: null,
      isReportVisible: false,
      base64Logo: null,
      loadingValue: 0,
      loadingMessage: '',
      lockoutPeriod: false,
      lockoutMessage: '',
      unApprovedTicketCount: 0,
      uninvoicedTickets: [],
      // ticketsOnUnapprovedJobsCount: 0,
      rules: {
        required: value => !!value || 'Required.',
        alphaNumeric: value => /^[a-zA-Z0-9]*$/.test(value) || 'Only letters and numbers are allowed.',
        emailMatch: () =>
          !this.usedInvoiceNumbers.includes(this.invoiceNumber) || `That invoice number has already been used`,
      },
      icons: {
        mdiUpload,
        mdiFileEyeOutline,
      },
      showApprovedTickets: true,
    }
  },
  components: {
    CBSTotalsv2,
    HalfCircleSpinner,
    CBSDatav2,
  },
  methods: {
    async rollbackInvoiceSubmission() {
      console.log('Rolling back invoice submission due to API failure')
      console.log('Invoice details for rollback:', {
        invoiceNumber: this.invoiceNumber,
        selectedOrg: sessionStorage.selectedOrg,
        ticketCount: this.ticketList?.length || 0,
        timestamp: new Date().toISOString(),
      })
      try {
        // Remove PDF from storage
        const storageRef = firebase
          .storage()
          .ref(`${sessionStorage.selectedOrg}/invoices/${this.invoiceNumber}/generatedPDF`)
        await storageRef.delete()

        // Remove invoice document from Firestore
        await firebase
          .firestore()
          .collection('orgs')
          .doc(sessionStorage.selectedOrg)
          .collection('invoices')
          .doc(this.invoiceNumber)
          .delete()

        // Remove invoice number from usedInvoiceNumbers array
        const index = this.usedInvoiceNumbers.indexOf(this.invoiceNumber)
        if (index > -1) {
          this.usedInvoiceNumbers.splice(index, 1)
          await firebase.firestore().collection('orgs').doc(sessionStorage.selectedOrg).update({
            invoiceNumbers: this.usedInvoiceNumbers,
          })
        }

        console.log('Invoice submission rollback completed successfully')
        console.log('Rollback completed for invoice:', this.invoiceNumber)

        // Send notification that rollback was needed (indicates a failure occurred)
        await this.sendFailureNotification(
          'Invoice Submission Failed - Rollback Completed',
          new Error('Invoice submission failed, rollback was successful'),
          {
            rollbackSuccessful: true,
            invoiceNumber: this.invoiceNumber,
          },
        )
      } catch (rollbackError) {
        console.error('Error during rollback:', rollbackError)
        console.error('Rollback failure details:', {
          invoiceNumber: this.invoiceNumber,
          selectedOrg: sessionStorage.selectedOrg,
          error: rollbackError.message,
          timestamp: new Date().toISOString(),
        })
        this.showError('Critical error: Failed to rollback invoice submission. Please contact support.')

        // Send failure notification for rollback failures
        await this.sendFailureNotification('Rollback Failure', rollbackError, {
          originalFailureContext: 'Invoice submission failed and rollback also failed',
          rollbackAttempted: true,
        })
      }
    },
    async retryApiCall(apiCall, maxRetries = 3, delay = 1000) {
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          console.log(`API call attempt ${attempt} of ${maxRetries}`)
          const result = await apiCall()
          return result
        } catch (error) {
          console.log(`API call attempt ${attempt} failed:`, error)

          // Categorize error types
          const isNetworkError =
            error.code === 'NETWORK_ERROR' ||
            error.code === 'ECONNREFUSED' ||
            error.code === 'ENOTFOUND' ||
            error.message?.includes('Network Error')

          const isTimeoutError = error.code === 'ECONNABORTED' || error.message?.includes('timeout')

          const isServerError = error.response?.status >= 500

          const isClientError = error.response?.status >= 400 && error.response?.status < 500

          // Don't retry on client errors (4xx)
          if (isClientError) {
            console.log('Client error detected, not retrying')
            throw error
          }

          if (attempt === maxRetries) {
            throw error
          }

          // Longer delay for server errors
          const retryDelay = isServerError ? delay * attempt * 2 : delay * attempt
          console.log(`Retrying in ${retryDelay}ms...`)
          await new Promise(resolve => setTimeout(resolve, retryDelay))
        }
      }
    },
    async sendEmail(pdfBlob = null) {
      try {
        // Validate required data
        if (!this.orgData || !this.invoiceNumber) {
          throw new Error('Missing required data for email')
        }

        let blob = pdfBlob
        if (!blob) {
          // Generate PDF if not provided
          const docDefinition = generateDocDefinition(
            this.revenue,
            this.deductions,
            this.afterCommission,
            this.totals,
            this.ticketList,
            this.selectedMonth,
            this.invoiceDate,
            this.invoiceNumber,
            this.selectedUnit,
            this.orgData,
            this.base64Logo,
          )

          blob = await new Promise(resolve => {
            const pdfDocGenerator = pdfMake.createPdf(docDefinition)
            pdfDocGenerator.getBlob(resolve)
          })
        }

        const formData = new FormData()
        formData.append('file', blob)

        const emailData = {
          orgData: this.orgData,
          userData: JSON.parse(sessionStorage.userData),
          selectedMonth: this.selectedMonth,
          selectedUnit: this.selectedUnit,
          invoiceDate: this.invoiceDate,
          invoiceNumber: this.invoiceNumber,
          orgId: sessionStorage.selectedOrg,
          to: 'admin@jdcservices.ca',
          cc: `${JSON.parse(sessionStorage.userData).email}, a.morin@jdcservices.ca`,
          //to: 'dolangiffin@outlook.com',
          //cc: `${JSON.parse(sessionStorage.userData).email}`,
        }

        const emailApiCall = () =>
          axios.post(
            // 'http://127.0.0.1:5001/jdcservices-69fd4/us-central1/invoiceCreatedEmail',
            'https://us-central1-jdcservices-69fd4.cloudfunctions.net/invoiceCreatedEmail',
            formData,
            {
              params: emailData,
              timeout: 30000, // 30 second timeout
            },
          )

        const response = await this.retryApiCall(emailApiCall, 3, 2000)

        if (response.status === 200) {
          console.log('Email sent successfully for invoice:', this.invoiceNumber)
          return true
        } else {
          console.error('Email API returned non-200 status:', response.status)
          return false
        }
      } catch (error) {
        console.error('Email sending failed:', error)

        // Provide specific error messages
        let errorMessage = 'Error sending invoice email'
        if (error.message?.includes('timeout')) {
          errorMessage = 'Email sending timed out - please try again'
        } else if (error.response?.status === 413) {
          errorMessage = 'Email attachment too large - please contact support'
        } else if (error.response?.status >= 500) {
          errorMessage = 'Email server error - please try again later'
        } else if (error.code === 'NETWORK_ERROR') {
          errorMessage = 'Network error sending email - please check connection'
        }

        this.showError(errorMessage)
        return false
      }
    },
    async sendFailureNotification(failureType, error, context = {}) {
      try {
        const userData = JSON.parse(sessionStorage.userData)
        const timestamp = new Date().toISOString()

        const emailData = {
          to: 'admin@jdcservices.ca',
          //to: 'dolangiffin@outlook.com',
          subject: `Invoice Submission Failure - ${failureType}`,
          body: `
            <h3>Invoice Submission Failed</h3>
            <p><strong>Failure Type:</strong> ${failureType}</p>
            <p><strong>Time:</strong> ${timestamp}</p>
            <p><strong>User:</strong> ${userData.name} (${userData.email})</p>
            <p><strong>Organization:</strong> ${sessionStorage.selectedOrg}</p>
            <p><strong>Invoice Number:</strong> ${this.invoiceNumber || 'N/A'}</p>
            <p><strong>Selected Month:</strong> ${this.selectedMonth || 'N/A'}</p>
            <p><strong>Selected Unit:</strong> ${this.selectedUnit?.name || 'N/A'}</p>
            <p><strong>Ticket Count:</strong> ${this.ticketList?.length || 0}</p>

            <h4>Error Details:</h4>
            <pre>${error.message || error}</pre>

            ${error.stack ? `<h4>Stack Trace:</h4><pre>${error.stack}</pre>` : ''}

            <h4>Additional Context:</h4>
            <pre>${JSON.stringify(context, null, 2)}</pre>
          `,
        }

        const notificationCall = () =>
          axios.post('https://us-central1-jdcservices-69fd4.cloudfunctions.net/sendFailureNotification', emailData, {
            timeout: 10000, // 10 second timeout
            headers: {
              'Content-Type': 'application/json',
            },
          })

        // Try to send notification (don't retry to avoid infinite loops)
        await notificationCall()
        console.log('Failure notification sent successfully')
      } catch (notificationError) {
        console.error('Failed to send failure notification:', notificationError)
      }
    },
    viewPDF() {
      const lockoutPeriodActive = this.checkForLockoutPeriod()
      if (!lockoutPeriodActive) {
        let docDefinition = generateDocDefinition(
          this.revenue,
          this.deductions,
          this.afterCommission,
          this.totals,
          this.ticketList,
          this.selectedMonth,
          this.invoiceDate,
          this.invoiceNumber,
          this.selectedUnit,
          this.orgData,
          this.base64Logo,
        )
        pdfMake.createPdf(docDefinition).download(`${this.invoiceNumber}.pdf`)
      }
    },
    updateDocDefinition(docDefinition) {
      this.docDefinition = docDefinition
    },
    isSubmitDisabled() {
      return (
        !this.agreement ||
        !this.invoiceDate ||
        this.usedInvoiceNumbers.includes(this.invoiceNumber) ||
        !this.invoiceNumber ||
        this.submitLoading ||
        this.unApprovedTicketCount > 0 ||
        this.uninvoicedTickets.length > 0
      )
    },
    updateTotals(totals, revenue, deductions, afterCommission) {
      this.totals = totals
      this.revenue = revenue
      this.deductions = deductions
      this.afterCommission = afterCommission
    },
    async submitInvoice() {
      const lockoutPeriodActive = this.checkForLockoutPeriod()
      if (!this.isSubmitDisabled() && !lockoutPeriodActive) {
        //this ticket list length limit is enforced due to the size of the string that we allow in the SQL database,
        //this can be changed if we want to raise it in the future
        if (this.ticketList.length > 300) {
          this.showError('Too many tickets on invoice, please contact support')
          return
        }
        this.loadingValue = 0
        this.loadingMessage = 'Generating PDF'
        this.submitLoading = true
        const userData = JSON.parse(sessionStorage.userData)

        let url
        let pdfBlob
        //add the pdf to storage
        try {
          let docDefinition = generateDocDefinition(
            this.revenue,
            this.deductions,
            this.afterCommission,
            this.totals,
            this.ticketList,
            this.selectedMonth,
            this.invoiceDate,
            this.invoiceNumber,
            this.selectedUnit,
            this.orgData,
            this.base64Logo,
          )
          const pdfDocGenerator = pdfMake.createPdf(docDefinition)
          const storageRef = firebase
            .storage()
            .ref(`${sessionStorage.selectedOrg}/invoices/${this.invoiceNumber}/generatedPDF`)
          const wait = () =>
            new Promise(resolve => {
              pdfDocGenerator.getBlob(async blob => {
                pdfBlob = blob // Store blob for email reuse
                await storageRef.put(blob)
                url = await storageRef.getDownloadURL()
                resolve()
              })
            })
          await wait()
          this.showSuccess('PDF uploaded to storage')
          this.loadingValue = 15
          this.loadingMessage = 'Updating Database'
        } catch (error) {
          console.log(error)
          this.showError('Error uploading pdf to storage')
          this.submitLoading = false

          // Send failure notification for PDF upload failure
          await this.sendFailureNotification('PDF Upload Failure', error, {
            step: 'PDF Generation and Storage Upload',
            invoiceNumber: this.invoiceNumber,
          })
          return
        }

        // add the invoice to the orgs invoice collection
        // Note: We write the invoiceMonth as the third of the selectedMonth in UTC time to eliminate timezone issues.
        //       For example, if the selected month is 2025-03 and we put it into firestore as new Date('2025-3'), depending on the
        //       timezone the user is in, it could potentially convert it to February 28th. We set it to the second of the month
        //       to eliminate timezone issues for the submitted invoices report. With it set to the third day, it doesn't matter what
        //       time zone the user is in, when the date is converted to their timezone, it will convert it to a date within the correct month.
        try {
          await firebase
            .firestore()
            .collection('orgs')
            .doc(sessionStorage.selectedOrg)
            .collection('invoices')
            .doc(this.invoiceNumber)
            .set({
              totals: this.totals,
              invoiceDate: new Date(moment(this.invoiceDate)),
              invoiceMonth: moment.utc(this.selectedMonth, 'YYYY-MM').startOf('month').add(2, 'days').toDate(),
              unit: this.selectedUnit,
              submittedBy: { name: userData.name, uid: userData.uid },
              submittedDate: new Date(Date.now()),
              pdfURLs: { generated: url, uploaded: null },
              invoiceEmailed: false,
              receivedByAdmin: false,
            })
          this.showSuccess('Invoice uploaded to database')
          this.loadingValue = 40
          this.loadingMessage = 'Submitting Invoice'
        } catch (error) {
          console.log(error)
          this.showError('Error uploading invoice to database')
          this.submitLoading = false

          // Send failure notification for database upload failure
          await this.sendFailureNotification('Database Upload Failure', error, {
            step: 'Invoice Document Creation in Firestore',
            invoiceNumber: this.invoiceNumber,
            pdfUploaded: true, // PDF was successfully uploaded
          })
          return
        }

        //update the orgs invoice numbers with the new invoice number
        try {
          this.usedInvoiceNumbers.push(this.invoiceNumber)
          await firebase.firestore().collection('orgs').doc(sessionStorage.selectedOrg).update({
            invoiceNumbers: this.usedInvoiceNumbers,
          })
          this.showSuccess('Invoice submitted succesfully')
          this.loadingValue = 60
          this.loadingMessage = 'Marking Tickets as Invoiced'
        } catch (error) {
          console.log(error)
          this.showError('Invoice submission failed')
          this.submitLoading = false

          // Send failure notification for invoice number update failure
          await this.sendFailureNotification('Invoice Number Update Failure', error, {
            step: 'Adding Invoice Number to Organization',
            invoiceNumber: this.invoiceNumber,
            pdfUploaded: true,
            invoiceDocumentCreated: true,
          })
          return
        }

        //update the tickets in the SQL database to show as invoiced by the contractor
        try {
          let userData = JSON.parse(sessionStorage.userData)

          console.log('Data passed to API to update invoiced tickets: ', {
            ticketNums: this.ticketNumbers,
            invoiced: 'Yes',
            invoicedBy: userData.name,
            invoicedNumber: this.invoiceNumber,
          })

          const apiCall = () =>
            axios.post(
              // 'https://localhost:44370/api/Tickets/update-contractor-invoiced',
              'https://wilard-api-bnemcjeydyhjgeek.canadacentral-01.azurewebsites.net/api/Tickets/update-contractor-invoiced',
              {
                ticketNums: this.ticketNumbers,
                invoiced: 'Yes',
                invoicedBy: userData.name,
                invoicedNumber: this.invoiceNumber,
              },
              {
                headers: { ApiKey: process.env.VUE_APP_WILARD_API_KEY },
                // headers: { ApiKey: 'd&EJ5&VaCyyN8wZAs' },
              },
            )

          const response = await this.retryApiCall(apiCall, 3, 1000)

          // instantiate a Set to hold only unique ticket nums from the table, Sets only allow unique values to be added
          const uniqueTicketNums = new Set()

          this.ticketList.forEach(item => {
            uniqueTicketNums.add(item.ticketNum)
          })

          if (response.data === uniqueTicketNums.size) {
            //success
            this.showSuccess('Tickets Marked as Invoiced succesfully')
            this.loadingValue = 75
            this.loadingMessage = 'Updating Notifications'

            // Sync to Supabase via Railway API
            RailwayApiService.syncContractorInvoiced(this.ticketNumbers, userData.name, this.invoiceNumber)
          } else {
            this.showError('API returned unexpected response - not all tickets were marked as invoiced')
            await this.rollbackInvoiceSubmission()
            this.submitLoading = false
            this.loadingValue = 0
            this.loadingMessage = ''
            return
          }
        } catch (error) {
          console.error('Failed to mark tickets as invoiced after retries:', error)

          // Provide specific error messages based on error type
          let errorMessage = 'Failed to mark tickets as invoiced - rolling back invoice submission'
          if (error.response?.status === 401) {
            errorMessage = 'Authentication failed with ticket API - rolling back invoice submission'
          } else if (error.response?.status === 403) {
            errorMessage = 'Access denied to ticket API - rolling back invoice submission'
          } else if (error.response?.status >= 500) {
            errorMessage = 'Ticket API server error - rolling back invoice submission'
          } else if (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error')) {
            errorMessage = 'Network error connecting to ticket API - rolling back invoice submission'
          } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
            errorMessage = 'Timeout connecting to ticket API - rolling back invoice submission'
          }

          this.showError(errorMessage)
          await this.rollbackInvoiceSubmission()
          this.submitLoading = false
          this.loadingValue = 0
          this.loadingMessage = ''

          // Send failure notification for ticket API failure
          await this.sendFailureNotification('Ticket API Failure', error, {
            step: 'Marking Tickets as Invoiced',
            invoiceNumber: this.invoiceNumber,
            ticketCount: this.ticketList?.length || 0,
            allPriorStepsCompleted: true,
            errorType: error.response?.status || error.code || 'unknown',
          })
          return
        }

        //Update notifications for tickets that have been invoiced as invoiced in firebase
        try {
          const notificationPromises = this.ticketNumbers.map(async ticketNum => {
            const querySnapshot = await firebase
              .firestore()
              .collection('modifiedTickets')
              .where('ticketNum', '==', Number(ticketNum))
              .get()
            if (!querySnapshot.empty) {
              const page = querySnapshot.docs[0]
              await page.ref.update({ invoiced: true })
            }
          })
          await Promise.all(notificationPromises)
          this.showSuccess('Notifications updated succesfully')
          this.loadingValue = 90
          this.loadingMessage = 'Emailing Admin'
        } catch (error) {
          console.log(error)
          this.showError('Notification update failed')
          this.submitLoading = false

          // Send failure notification for Firebase notification update failure
          await this.sendFailureNotification('Firebase Notification Update Failure', error, {
            step: 'Updating Firebase Notifications',
            invoiceNumber: this.invoiceNumber,
            ticketCount: this.ticketList?.length || 0,
            ticketsMarkedAsInvoiced: true,
          })
          return
        }

        //send email with invoice info and pdf attached
        let emailSuccessful = await this.sendEmail(pdfBlob)
        if (emailSuccessful) {
          this.loadingValue = 100
          this.submitLoading = false
          this.invoiceSubmitted = true
          this.showSuccess('Invoice Email Sent')
          // update invoiceEmailed field to true in invoice doc
          // (the email function also does this, this is a fallback in case its update failed)
          try {
            await firebase
              .firestore()
              .collection('orgs')
              .doc(sessionStorage.selectedOrg)
              .collection('invoices')
              .doc(this.invoiceNumber)
              .update({ invoiceEmailed: true })
          } catch (err) {
            console.log('Error updating the invoice emailed status in the database: ', err)
            this.showError('Error updating the invoice emailed status in the database')
          }
        } else {
          console.log('Email failed but invoice was successfully created')
          this.submitLoading = false
          this.loadingValue = 0
          this.loadingMessage = ''
          this.showError('Invoice was created but email failed to send. Please contact support to resend the email.')
        }
      }
    },
    // Coalesce the selectedUnit/selectedMonth watchers so a unit+month selection loads once, not twice.
    queueSelectionLoad: function () {
      if (!(this.selectedMonth && this.selectedUnit)) {
        return
      }
      if (this._selectionLoadQueued) {
        return
      }
      this._selectionLoadQueued = true
      this.$nextTick(() => {
        this._selectionLoadQueued = false
        this.agreement = false
        this.invoiceNumber = null
        this.invoiceDate = null
        this.invoiceSubmitted = false
        this.checkForLockoutPeriod()
        this.getCBSData()
        this.getUninvoicedTickets()
      })
    },
    getCBSData: async function () {
      try {
        this.isLoadingCbs = true
        const response = await axios.post(
          // 'https://localhost:44370/api/Tickets/contractor-balance-sheet',
          'https://wilard-api-bnemcjeydyhjgeek.canadacentral-01.azurewebsites.net/api/Tickets/contractor-balance-sheet',
          {
            unitID: this.selectedUnit.toString(),
            production: 'Yes,No,N12,D15,T0,L12,P15',
            commision: '0.15',
            dateA: moment(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
            dateB: moment(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
            customer: '0',
            operations: ' ',
          },
          {
            headers: { ApiKey: process.env.VUE_APP_WILARD_API_KEY },
            // headers: { ApiKey: 'd&EJ5&VaCyyN8wZAs' },
          },
        )

        const initialTicketList = await generateTicketList(response.data, {
          includeRecentTickets: this.includeRecentTickets,
        })
        let ticketListWithInvoicedCopy = JSON.parse(JSON.stringify(initialTicketList))

        // Flag whether each ticket's job was approved before, and whether the ticket was created before the
        // job's last edit. jobApprovedDate + timeCreated already come back on the balance-sheet response (carried
        // through generateTicketList), so no per-ticket lookup is needed. The only Firestore read is the
        // modifiedJobsWilard "last edit" time, batched by unique jobID.
        const uninvoicedTickets = ticketListWithInvoicedCopy.filter(ticket => !ticket.contractorInvoiced)
        const approvedJobIDs = [
          ...new Set(uninvoicedTickets.filter(ticket => ticket.jobApprovedDate).map(ticket => ticket.jobID)),
        ]
        const lastEditByJobID = await this.getLastJobEditTimes(approvedJobIDs)

        uninvoicedTickets.forEach(ticket => {
          if (ticket.jobApprovedDate) {
            ticket.jobHasBeenCompletedBefore = true
            const lastEditTime = lastEditByJobID.get(ticket.jobID)
            ticket.ticketCreatedBeforeLastJobEdit = lastEditTime
              ? new Date(ticket.timeCreated) < lastEditTime.toDate()
              : false
          } else {
            ticket.jobHasBeenCompletedBefore = false
          }
        })
        this.ticketListWithInvoiced = ticketListWithInvoicedCopy
      } catch (error) {
        console.error('Error in getCBSData:', error)
        this.showError('Error getting ticket data')
      } finally {
        this.isLoadingCbs = false
      }
    },
    // Batch-fetch the last edit time per jobID from modifiedJobsWilard (Firestore 'in' supports 10 values/query).
    getLastJobEditTimes: async function (jobIDs) {
      const lastEditByJobID = new Map()
      const ids = (jobIDs || []).filter(id => id !== null && id !== undefined)
      if (ids.length === 0) {
        return lastEditByJobID
      }
      const db = firebase.firestore()
      const chunks = []
      for (let i = 0; i < ids.length; i += 10) {
        chunks.push(ids.slice(i, i + 10))
      }
      await Promise.all(
        chunks.map(async chunk => {
          try {
            const snapshot = await db.collection('modifiedJobsWilard').where('jobID', 'in', chunk).get()
            snapshot.docs.forEach(doc => {
              const data = doc.data()
              lastEditByJobID.set(data.jobID, data.lastUpdated)
            })
          } catch (error) {
            console.error(`Error fetching modifiedJobsWilard for jobIDs ${chunk}:`, error)
          }
        }),
      )
      return lastEditByJobID
    },
    checkInvoiceNumber() {
      return this.usedInvoiceNumbers.includes(this.invoiceNumber)
    },
    async getUninvoicedTickets() {
      try {
        this.isLoadingUninvoicedTickets = true
        const response = await axios.post(
          'https://wilard-api-bnemcjeydyhjgeek.canadacentral-01.azurewebsites.net/api/Tickets/contractor-balance-sheet',
          // 'https://localhost:44370/api/Tickets/contractor-balance-sheet',
          {
            unitID: this.selectedUnit.toString(),
            production: 'Yes,No,N12,D15,T0,L12,P15',
            commision: '0.15',
            dateA: moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'), // 6 months from today (Set to first of month)
            dateB: moment(this.selectedMonth).startOf('month').subtract(1, 'days').format('YYYY-MM-DD'),
            customer: '0',
            operations: '',
          },
          {
            headers: { ApiKey: process.env.VUE_APP_WILARD_API_KEY },
            // headers: { ApiKey: 'd&EJ5&VaCyyN8wZAs' },
          },
        )
        const ticketList = response.data
        this.uninvoicedTickets = await generateTicketList(ticketList, {
          includeRecentTickets: this.includeRecentTickets,
        })
        // filter out tickets that have already been invoiced
        this.uninvoicedTickets = this.uninvoicedTickets.filter(ticket => ticket.contractorInvoiced === false)
      } catch (err) {
        console.log(`Error getting CBS data: ${err}`)
        this.$toasted.show('Error getting CBS data', {
          duration: null,
          keepOnHover: true,
          type: 'error',
        })
      } finally {
        this.isLoadingUninvoicedTickets = false
      }
    },
    getOrgData: function () {
      try {
        firebase
          .firestore()
          .collection('orgs')
          .doc(sessionStorage.selectedOrg)
          .get()
          .then(doc => {
            if (doc.exists) {
              this.orgData = doc.data()
              this.units = doc.data().units ? doc.data().units : []
              this.units.sort()
              this.usedInvoiceNumbers = doc.data().invoiceNumbers ? doc.data().invoiceNumbers : []
              //if they have uploaded a logo, get the url.
              if (doc.data().logoURL != undefined) {
                this.getBase64ImageFromURL(doc.data().logoURL).then(resp => {
                  this.base64Logo = resp
                })
              }
            }
          })
          .catch(err => {
            console.log(`Error executing get org data function: ${err}`)
            this.showError('Error sending organization info')
          })
      } catch (err) {
        console.log(`Error getting org data: ${err}`)
        this.showError('Error sending org data')
      }
    },
    checkForLockoutPeriod() {
      let lockoutPeriodActive = false
      const today = moment(Date.now()).format('YYYY-MM-DD')
      const first = moment().startOf('month').format('YYYY-MM-DD')
      const second = moment(first).add(1, 'days').format('YYYY-MM-DD')
      const third = moment(second).add(1, 'days').format('YYYY-MM-DD')

      if ((today === first || today === second || today === third) && !this.overrideLockoutPeriod) {
        const fourth = moment(third).add(1, 'days').format('MMMM Do')
        lockoutPeriodActive = true
        this.lockoutPeriod = true
        this.lockoutMessage = `Invoice Submission is currently locked. Contractors can not submit invoices on the 1st, 2nd, or 3rd of the month. Please come back on ${fourth}.`
        alert(this.lockoutMessage)
      } else {
        lockoutPeriodActive = false
        this.lockoutPeriod = false
      }

      return lockoutPeriodActive
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image()
        // img.setAttribute('crossOrigin', 'anonymous')
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          var canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          var ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          var dataURL = canvas.toDataURL('image/png')
          resolve(dataURL)
        }
        img.onerror = error => {
          reject(error)
        }
        img.src = url
      })
    },
    showSuccess: function (message) {
      this.$toasted.show(message, {
        duration: '9000',
        keepOnHover: true,
        type: 'success',
      })
    },
    showError: function (message) {
      this.$toasted.show(message, {
        duration: null,
        keepOnHover: true,
        type: 'error',
      })
    },
    updateApprovedTicketCount: function (data) {
      //this is emitted from the CBSDATA component and will provide us with a count of unapproved tickets.
      this.unApprovedTicketCount = data.unapprovedTicketCount
    },
    handleVisibilityChange: function () {
      if (!document.hidden) {
        // user returned to the page, check for the lockout period again
        this.checkForLockoutPeriod()
      }
    },
    handleBeforeUnload: function (event) {
      if (this.submitLoading) {
        // prompt the user before they close, refresh or leave the page while the invoice is still being submitted
        event.preventDefault()
        event.returnValue = ''
      }
    },
  },
  watch: {
    selectedMonth() {
      this.queueSelectionLoad()
    },
    selectedUnit() {
      this.queueSelectionLoad()
    },
    overrideLockoutPeriod(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkForLockoutPeriod()
      }
    },
    includeRecentTickets(newVal, oldVal) {
      // The setting can be toggled from the app bar while this page is open, so reload the ticket data.
      if (newVal !== oldVal && this.selectedMonth && this.selectedUnit) {
        this.getCBSData()
        this.getUninvoicedTickets()
      }
    },
    // ticketList() {
    //   this.ticketsOnUnapprovedJobsCount = this.ticketList.filter(o => o.jobApproved === false).length
    // },
  },
  computed: {
    ticketList() {
      //ticketListWithInvoiced includes invoiced tickets, ticketList does not
      return this.ticketListWithInvoiced === null
        ? null
        : this.ticketListWithInvoiced.filter(x => x.contractorInvoiced !== true)
    },
    ticketNumbers() {
      //returns an array of only the ticket numbers of the tickets that are on the invoice
      if (this.ticketList !== null && Array.isArray(this.ticketList)) {
        let tempArr = []
        for (let i = 0; i < this.ticketList.length; i++) {
          tempArr.push(this.ticketList[i].ticketNum.toString())
        }
        return tempArr
      }
      return []
    },
    overrideLockoutPeriod() {
      return this.$store.state.userData?.settings?.overrideLockoutPeriod || false
    },
    // When the 6 hour delay is disabled, tickets/charges created in the last 6 hours are included.
    includeRecentTickets() {
      return this.$store.state.appSettings.disableSixHourDelay
    },
  },
  mounted() {
    this.getOrgData()
    this.checkForLockoutPeriod()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
}
</script>

<style></style>
